import {useState, useEffect} from 'react';
import { useSelector, useDispatch } from 'react-redux';

import {Grid, Box,Typography} from '@mui/material';
import FieldView from 'core/components/layout/FieldView';
import {setFoodcompositionSorting} from 'store/slice/PharmaSlice';

export default function FoodcompositionListTableHeader(){
  const dispatch = useDispatch();
  const {sorting} = useSelector((state) => state.pharmaslice.foodcompositionDashboard);
  
  const handleColumnClick = (column) => {
  const currentSorting = sorting.column === column ? !sorting.asc : true;
    dispatch(setFoodcompositionSorting({ column, asc: currentSorting }));     
  }
    return (
      
      <Grid container direction="row" sx={{ justifyContent: "flex-start", alignItems: "center", width: '100%', padding: 1, backgroundColor: 'primary.lighter' }}>

            {/* <HEADER - CELLS/> */}
        
                        <Grid item lg={8} xs={10} ><Typography variant="h5" sx={{cursor:'pointer'}} onClick={()=>handleColumnClick('title')}> Title </Typography></Grid>

      </Grid>
      
    )
}